<template>
  <button
    v-on="$listeners"
    :class="`app-form-reset trip-status-pill ${variant}`"
  >
    <loading
      :height="17"
      :opacity="0"
      :active="busy"
      :color="`#000`"
      :loader="`bars`"
      :is-full-page="false"
    />
    <div :style="`visibility: ${busy ? 'hidden' : 'visible'};`">
      {{ text }}
      <slot />
    </div>
  </button>
</template>

<script>
export default {
  name: 'TripStatusButton',

  props: {
    text: {
      type: String,
      required: true,
    },

    busy: {
      type: Boolean,
      default: false,
    },

    variant: {
      type: String,
      default: 'green',
      validator: (v) => {
        return [
          'fallback',
          'blue',
          'purple',
          'red',
          'green',
          'yellow',
          'orange',
        ].includes(v)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '$trip-status';
</style>
